export default __webpack_public_path__ + "static/media/Category-L-LVT.999d3840.jpg";